// -----------------------------------------------------------
// FloraIQ - ErrorState Unificado
// -----------------------------------------------------------

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export default function ErrorState({
  title = "Erro ao carregar dados",
  message = "Não foi possível carregar as informações. Verifique sua conexão e tente novamente.",
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-danger-100 flex items-center justify-center mb-4">
        <i className="ri-error-warning-line text-2xl text-danger-600"></i>
      </div>
      <h3 className="text-lg font-semibold text-foreground-800 font-heading mb-1">{title}</h3>
      <p className="text-sm text-foreground-500 max-w-sm mb-4">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-outline text-sm cursor-pointer">
          <i className="ri-refresh-line"></i>
          Tentar novamente
        </button>
      )}
    </div>
  );
}